var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['uploader', {'compact':_vm.compact}]},[_c('input',{ref:"hiddenField",attrs:{"type":"hidden","name":_vm.useFieldName},domProps:{"value":_vm.useValue}}),_vm._v(" "),_c('div',{ref:"dropzone",staticClass:"dropzone"})])
}
var staticRenderFns = []

export { render, staticRenderFns }